import APIController from '../core-api-controller';

export const fetchTrackingListApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/pharmacy_trackings${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchNewInfoApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/pharmacy_trackings/new${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const fetchEditInfoApi = (id = '') => {
  const path = `${APIController.endpointApi}/pharmacy_trackings/${id}/edit`;
  return APIController.getApiCallback(path);
};

export const fetchTrackingStateApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/pharmacy_trackings/fetch_tracking_state${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const createPharmacyTrackingApi = (data) => {
  const path = `${APIController.endpointApi}/pharmacy_trackings`;
  return APIController.postCallback(path, data);
};

export const updatePharmacyTrackingApi = (id, data) => {
  const path = `${APIController.endpointApi}/pharmacy_trackings/${id}`;
  return APIController.putCallback(path, data);
};
